import styled from 'styled-components';

// Colors
import * as colors from '@drivesally/sally-ui/lib/libs/colors';

const ChargeRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
  border-top: 1px solid ${colors.mediumBlueGrey};

  &:first-child {
    border-top: none;
    padding-top: 0;
  }
`;

export default ChargeRow;
